import { FC } from 'react';
import { ProductAttributeInterface } from '../../../../../../../../Interface/ProductAttribute';
import { ProductSizeInterface } from '../../../../../../../../Interface/ProductSize';
import { formatCurrencyEur, formatDate } from '../../../../../../../Helper/formatter';
import styles from './QuickViewProductInfo.module.scss?module';
import ShippingInfo from '../../../../../../ShippingInfo/ShippingInfo';
import DepositInfoPill from '../../../../../../DepositInfoPill/DepositInfoPill';

export interface QuickViewProductInfoProps {
  attribute: ProductAttributeInterface;
  productSize: ProductSizeInterface | undefined;
  showRegularPrice: boolean;
  isPriceRed: boolean;
  displayPrice: number | undefined;
}

const QuickViewProductInfo: FC<QuickViewProductInfoProps> = ({
  attribute,
  productSize,
  showRegularPrice,
  isPriceRed,
  displayPrice,
}) => {
  return (
    <div className={styles.InfoSection}>
      {/* Header: Brand, Title, Variant, Overlay */}
      <div className={styles.HeaderContainer}>
        <div className={styles.TitleGroup}>
          {productSize?.product?.brand?.name && (
            <div className={styles.BrandInfo}>
              {productSize.product.brand.name}
            </div>
          )}
          <h2 className={styles.ProductName}>
            {productSize?.product?.name || productSize?.name}
          </h2>
          <span className={styles.AttributeName}>{attribute.name}</span>
        </div>
      </div>

      {/* Price & Shipping Section */}
      <div className={styles.PriceSection}>
        <div className={styles.PriceValues}>
          {displayPrice != null && (
            <span
              className={isPriceRed ? styles.PriceRed : styles.PriceCurrent}
            >
              {formatCurrencyEur(displayPrice)}
            </span>
          )}
          {showRegularPrice && productSize?.price_regular != null && (
            <span className={styles.RegularPrice}>
              {formatCurrencyEur(productSize.price_regular)}
            </span>
          )}
        </div>

        {((productSize?.vpe != null && productSize.vpe > 0) ||
          productSize?.deposit_units_count) && (
          <div className={styles.ShippingSectionWrapper}>
            <DepositInfoPill
              depositPrice={productSize?.single_deposit_price}
              depositUnitsCount={productSize?.deposit_units_count}
            />
            {productSize?.vpe != null && productSize.vpe > 0 && (
              <ShippingInfo
                unitsPerCase={productSize.vpe}
                unitsPerPallet={productSize.units_per_pallet}
              />
            )}
          </div>
        )}
      </div>

      {/* Product Box Details */}
      <div className={styles.DetailsList}>
        {productSize?.category?.name && (
          <InfoRow label="Category" value={productSize.category.name} />
        )}

        {productSize?.unit_value != null && productSize?.unit_name && (
          <InfoRow
            label="Size"
            value={`${productSize.unit_value} ${productSize.unit_name}`}
          />
        )}

        {attribute?.eta != null && attribute?.eta && (
          <InfoRow label="ETA" value={`${formatDate(attribute.eta)}`} />
        )}

        {productSize?.msrp != null && productSize.msrp > 0 && (
          <InfoRow label="MSRP" value={formatCurrencyEur(productSize.msrp)} />
        )}
      </div>
    </div>
  );
};

export default QuickViewProductInfo;

const InfoRow: FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className={styles.InfoRow}>
    <span className={styles.InfoLabel}>{label}</span>
    <span className={styles.InfoValue}>{value}</span>
  </div>
);
